import { useQueryClient } from "@tanstack/react-query";

export const useClearCache = () => {
  const queryClient = useQueryClient();
  queryClient.removeQueries();
};
